import script from "./TechnicianTicketsView.vue?vue&type=script&setup=true&lang=js"
export * from "./TechnicianTicketsView.vue?vue&type=script&setup=true&lang=js"

import "./TechnicianTicketsView.vue?vue&type=style&index=0&id=1b686021&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b686021"]])

export default __exports__